<template>
  <div class="logo-text" :class="{ uppercase }">
    <div>camdo<strong>nhanh</strong></div>
  </div>
</template>

<script>
export default {
  name: 'LogoText',
  props: {
    uppercase: Boolean
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

.logo-text {
  display: inline-block;
  color: $geranium;

  &.uppercase {
    text-transform: uppercase;
  }
}
</style>
